import React, { PureComponent } from "react";
import Link from "gatsby-link";
import cx from "classnames";

class CaseStudyBlockText extends PureComponent {
  render() {
    const { study } = this.props;

    const ButtonType = () => {
      if (study.template === "CaseStudy") {
        return <CaseStudyButton />;
      }
      return <AboutButton />;
    };

    const CaseStudyButton = () =>
      <Link
        className={cx(
          "b--white b--solid br1 bw2 f-xxs f-xs-m ttu b white pv1 db ls-s bg-white-hover tc bg-animate",
          {
            "rust-hover": study.id == 1,
            "aqua-hover": study.id == 2,
            "sand-hover": study.id == 3
          }
        )}
        style={{ width: "164px" }}
        to={study.route}
      >
        View Case Study
      </Link>;

    const AboutButton = () =>
      <Link
        className="b--white b--solid br1 bw2 f-xxs f-xs-m ttu b white pv1 db ls-s bg-white-hover tc bg-animate orange-hover"
        style={{ width: "164px" }}
        to={study.route}
      >
        Read Our Story
      </Link>;

    return (
      <div className="h-100">
        <div className="h-100 ph2 pb2 ph3-m pb3-m ph5-l pb4-l w-100 w-50-l">
          <div className="flex flex-column justify-center items-start h-100 w-100">
            <h1 className="f-l f-xl-m f-xxl-l white fw3 pb2 pb3 w-100">
              {study.title}
            </h1>
            <ButtonType />
          </div>
        </div>
      </div>
    );
  }
}

export default CaseStudyBlockText;



// WEBPACK FOOTER //
// ./src/components/CaseStudyBlockText.js